<template>
  <div>
    <table
      style="width: 100%"
    >
      <tr>
        <td>
          <strong>Customer Support</strong>
        </td>
      </tr>
      <tr>
        <td>
          <a href="/support/">Contact Support</a>
        </td>
      </tr>
      <tr
        v-if="phone"
      >
        <td>
          <a :href="phoneUrl" style="color: initial">{{ prettyPhone }}</a>
        </td>
      </tr>
    </table>
    <br />
    <div
      v-if="hours"
    >
      <table
        style="width: 100%"
      >
        <tr>
          <td colspan="2">
            <strong>Hours Of Operation</strong>
          </td>
        </tr>
        <tr
          v-for="(hour, $index) in hours"
          :key="$index"
        >
          <td>{{ hour.day }}</td>
          <td v-if="hour.status + '' === '1'">{{ hour.open_time }} - {{ hour.closed_time }}</td>
          <td v-else>CLOSED</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
td {
  padding: 1px;
}
</style>

<script>
import { XConfig } from '@/models'
export default {
  computed: {
    phone () {
      const phoneConfig = XConfig.find('company_phone')
      return phoneConfig?.value || null
    },
    phoneUrl () {
      if (!this.phone) {
        return null
      }
      return 'tel://' + this.phone.replace(/\./g, '')
    },
    prettyPhone () {
      return this.phone.replace(/\./g, '-')
    },
    hours () {
      const hoursConfig = XConfig.find('hours')
      return hoursConfig?.value || []
    }
  }
}
</script>
